<template>
    <div>
        <nav-breadcrumb :menu="[{label: ' 代理人列表'}]"/>
        <div class="xzpadd10 bg-purple of">
            <data-table
                :table-data="tableData"
                :columns="columns"
                :page.sync="page"
                :pageSize.sync="pageSize"
                :filters.sync="filters"
                :actions="actions"
            />
        </div>
    </div>
</template>

<script>
    import xhr from '../../utils/xhr'
    import {xmlBuildQuery} from "../../filters/CommonActions";
    import Status2CN from "../../filters/Status2CN";
    import {removeItem} from "../../filters/CommonActions";
    import moment from 'moment'
    import Panel from "../../components/Panel";
    export default {
        name: "ProxyPersonList",
        data(){
            return{

                columns:[
                    {
                        type: 'index'
                    },
                    {
                        label: '姓名',
                        field: 'p__name'
                    },
                    {
                        label: '身份证号码',
                        field: 'p__IC'
                    },
                    {
                        label: '手机号',
                        field: 'p__contactNo'
                    },
                    {
                        label: '操作',
                        opts:[
                            {
                                label: '编辑',
                                class: 'el-icon-edit',
                                clickHandler:  (index, row)=>{
                                    this.$router.push({
                                        path: 'Add',
                                        query: {
                                            personId: row.p__personId
                                        }
                                    })

                                }
                            },
                            {
                                label: '删除',
                                class: 'el-icon-delete',
                                clickHandler: (index, row)=>{
                                    this.removeItem(index, row)
                                }
                            }
                        ]
                    }
                ],
                tableData: {
                    count: 0,
                    data: []
                },
                page: 1,
                pageSize: 20,
                actions: [
                    {
                        label: '新增',
                        class: 'el-button--primary',
                        clickHandler: ()=>{
                            this.$router.push({
                                path: 'Add'
                            })
                        }
                    }
                ],
                filters: {
                    labelWidth: '150px',
                    form: {
                        ba__customerName:'',
                        ba__customerContactNo:'',
                        ba__customerIC:'',
                        d__dealerId:'',
                        t__applicationDate:[],
                    },
                    columns: [
                        {
                            label: '姓名',
                            component: 'el-input',
                            field: 'ba__customerName',
                        },
                    ],
                    onSubmit:()=>{
                        this.page = 1
                        this.getData()
                    }
                }
            }
        },
        mounted() {
            this.getData()
        },
        computed: {
            filterParams() {
                return {
                    pageSize: this.pageSize,
                    pageOffset: (this.page - 1) * this.pageSize,
                  /*  'xlist.sort.dataField': 't.applicationDate',
                    'xlist.sort.order': 'desc'*/
                }
            },
        },
        watch: {
            filterParams: function (newVal) {
                this.getData()
            }
        },
        methods: {
            getData: function () {
                xhr.getProxyPersonList(
                    Object.assign({}, this.filterParams, xmlBuildQuery(this.filters)),
                    res=> {
                        try {
                            this.tableData = res.data
                        }catch(e){

                        }
                    })

            },
            removeItem: function (index, row) {
                removeItem(
                    xhr.updateProxyPerson,
                    {
                        'p.personId' : row.p__personId
                    },
                    res=>{
                        try {
                            if(res.data.status == 'success') {
                                this.getData()
                            }
                        }catch (e) {

                        }
                    }
                )
            },
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/fang/ProxyPersonList.vue